import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";

const ProtectedRoute = ({ children, permissionKey }) => {
  const { isAuthenticated, allowedRoutes, user } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!permissionKey || permissionKey === "PROTECTED" || permissionKey === "DASHBOARD" || user?.type === "SUPER") {
    return children;
  }

  const isAllowed = allowedRoutes && allowedRoutes.some(allowed =>
    allowed.key === permissionKey.toString() ||
    (allowed.children && allowed.children.some(child => child.key === permissionKey.toString()))
  );

  if (!isAllowed) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
